var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(" "+_vm._s(_vm.$t("message.not_exist_message"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }